

























































import Vue from "vue";
import { Store } from "./libs/Store";

export default Vue.extend({
  name: "app",
  data() {
    return {
      store: Store.state,
      componentKey: 1,
      online: true
    };
  },
  async created() {
    if (localStorage.getItem("user") != null)
      this.store.loggedInUser = JSON.parse(
        localStorage.getItem("user") ?? "{}"
      );

    this.store.culture = (localStorage.getItem("culture")
      ? localStorage.getItem("culture")
      : "nl-BE") as string;
    this.$i18n.locale = (localStorage.getItem("culture") == "fr-BE"
      ? "fr"
      : "nl") as string;

    import("./locales/relative-time-" + this.$i18n.locale + ".js").then(
      module => {
        this.store.relativeTimeLocale = module.locale;
      }
    );

    window.addEventListener("online", () => {
      this.updateConnectionStatus();
    });
    window.addEventListener("offline", this.updateConnectionStatus);
  },
  methods: {
    onLanguageChange: function() {
      this.componentKey += 1;

      import("./locales/relative-time-" + this.$i18n.locale + ".js").then(
        module => {
          this.store.relativeTimeLocale = module.locale;
        }
      );
      
    },
    updateConnectionStatus() {
      this.online = navigator.onLine;
    }
  },
  mounted() {
    
  },
  components: {
    
  }
});
